<template>
    <div 
      class="mt-4">
      <v-layout wrap>
        <v-flex>
          <v-snackbar
            v-model="dialog.snackbar"
            top
            right
            color="green">
            <span 
              class="body-1 font-weight-light white--text"
              v-html="message.success">
            </span>
  
            <template v-slot:action="{ attrs }">
              <v-btn
                icon
                color="white"
                class="body-1 font-weight-bold text-capitalize"
                v-bind="attrs"
                @click="dialog.snackbar = false">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-snackbar>
  
          <v-dialog v-model="dialog.freeze"
            @keydown.esc="dialog.freeze = false"
            :fullscreen="dialog.fullscreen"
            width="400"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pt-3 pb-0 text-right popup-header">
                Freeze Kolom
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mt-3 mb-2"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-text 
                class="py-0">
                <v-form>
                  <v-row>
                    <v-col>
                      <div>
                        <div 
                          class="mb-2">
                          Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                        </div>
  
                        <v-list-item-group
                          multiple>
                          <v-list flat>
                            <v-list-item 
                              v-for="(item, index) in configHeaders" 
                              :key="index"
                              class="px-0"
                              @click="item.freeze = !item.freeze ? true : false">
                              <v-list-item-action 
                                class="mr-4">
                                <v-checkbox
                                  :color="set_color"
                                  :input-value="item.freeze">
                                </v-checkbox>
                              </v-list-item-action>
  
                              <v-list-item-content>
                                <div
                                  :class="item.freeze ? 'font-weight-bold' : ''"
                                  :style="item.freeze ? `color: ${set_color};` : ''">
                                  {{ item.text }}
                                </div>
                              </v-list-item-content>
                            </v-list-item>  
                          </v-list>
                        </v-list-item-group>
                      </div>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
  
              <v-divider 
                class="mb-3 mt-0"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-actions
                class="mb-2">
                <v-spacer/>
  
                <v-btn
                  elevation="0"
                  :color="set_color"
                  style="border-radius: 10px;"
                  class="body-2 font-weight-bold text-capitalize white--text"
                  @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                  <v-icon small class="mr-1">mdi-check-bold</v-icon>
                  Freeze
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog.hide"
            @keydown.esc="dialog.hide = false"
            :fullscreen="dialog.fullscreen"
            width="400"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pt-3 pb-0 text-right popup-header">
                Hide Kolom
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.hide = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mt-3 mb-2"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-text 
                class="py-0">
                <v-form>
                  <v-row>
                    <v-col>
                      <div>
                        <div class="mb-2">
                          Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                        </div>
  
                        <v-list-item-group
                          multiple>
                          <v-list flat>
                            <v-list-item 
                              v-for="(item, index) in headers" 
                              :key="index"
                              class="px-0"
                              @click="item.hide = !item.hide ? true : false">
                              <v-list-item-action 
                                class="mr-4">
                                <v-checkbox
                                  :color="set_color"
                                  :input-value="item.hide">
                                </v-checkbox>
                              </v-list-item-action>
  
                              <v-list-item-content>
                                <div
                                  :class="item.hide ? 'font-weight-bold' : ''"
                                  :style="item.hide ? `color: ${set_color};` : ''">
                                  {{ item.text }}
                                </div>
                              </v-list-item-content>
                            </v-list-item>  
                          </v-list>
                        </v-list-item-group>
                      </div>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
  
              <v-divider 
                class="mb-3 mt-0"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-actions
                class="mb-2">
                <v-spacer/>
  
                <v-btn
                  elevation="0"
                  :color="set_color"
                  style="border-radius: 10px;"
                  class="body-2 font-weight-bold text-capitalize white--text"
                  @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                  <v-icon small class="mr-1">mdi-check-bold</v-icon>
                  Hide
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog.filter"
            @keydown.esc="dialog.filter = false"
            :fullscreen="dialog.fullscreen"
            width="600"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                <div
                  class="title font-weight-bold">
                  Filter Data
                </div>
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.filter = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-text 
                class="py-0 my-4">
                <div>
                  
                </div>
              </v-card-text>
              
              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-actions
                class="pa-4">
                <v-spacer/>
  
                <v-btn 
                  @click="dialog.filter = false; fetch();"
                  width="120"
                  elevation="0"
                  color="green"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Filter
                </v-btn>
  
                <v-btn 
                  @click="dialog.filter = false"
                  :disabled="process.form"
                  width="120"
                  outlined
                  elevation="0"
                  color="red"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog.form"
            @keydown.esc="dialog.form = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center px-4 py-2 text-right popup-header">
                <div
                  class="fs-16 font_weight_700">
                  {{ form.id === '' ? 'Tambah' : 'Ubah' }} {{ $route.meta.title }}
                </div>
  
                <v-spacer/>
  
                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon> -->
  
                <v-icon 
                  @click="dialog.form = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="22"
                  color="#9ca3af">
                  mdi-close
                </v-icon>
              </v-card-title>
  
              <v-divider 
                class="mt-0"
                style="border-top: 1px solid #e0e0e0;"/>
  
              <v-card-text 
                class="py-0 my-4">
                <ValidationObserver 
                  ref="form">
                  <v-form>
                    <ValidationProvider 
                      name="Nama Mata Pelajaran" 
                      rules="required" 
                      v-slot="{ errors }">
                      <div class="fs-13 mb-1">
                        
                        Nama Mata Pelajaran
                        <span class="red--text">*</span>
                      </div>
  
                      <v-text-field
                        v-on:keyup.enter="save()"
                        
                        solo
                        rounded
                        dense
  
                        :color="set_color"
                        placeholder="Contoh. IPA"
  
                        
  
                        v-model="form.name"
                        :error-messages="errors"
                        required
                        style="border-radius: 10px;"
                        class="mb-0">
                      </v-text-field>
                    </ValidationProvider>
  
                    <ValidationProvider 
                      name="Kode" 
                      rules="required" 
                      v-slot="{ errors }">
                      <div class="fs-13 mb-1">
                        
                        Kode
                        <span class="red--text">*</span>
                      </div>
  
                      <v-text-field
                        v-on:keyup.enter="save()"
                        
                        solo
                        rounded
                        dense
  
                        :color="set_color"
                        placeholder="Contoh. IPA"
  
                        
  
                        v-model="form.code"
                        :error-messages="errors"
                        required
                        style="border-radius: 10px;"
                        class="mb-0">
                      </v-text-field>
                    </ValidationProvider>
                    <v-row>
                      <v-col cols="12" md="6" class="py-0">
                        <ValidationProvider 
                          name="Singkatan" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="fs-13 mb-1">
                            
                            Singkatan
                            <span class="red--text">*</span>
                          </div>
      
                          <v-text-field
                            v-on:keyup.enter="save()"
                            
                            solo
                            rounded
                            dense
      
                            :color="set_color"
                            placeholder="Contoh. IPA"
      
                            
      
                            v-model="form.singkatan"
                            :error-messages="errors"
                            required
                            style="border-radius: 10px;"
                            class="mb-0">
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" md="6" class="py-0">
                        <ValidationProvider 
                          name="Durasi" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="fs-13 mb-1">
                            
                            Durasi
                            <span class="red--text">*</span>
                          </div>
      
                          <v-currency-field
                            v-on:keyup.enter="save()"
                            
                            solo
                            rounded
                            dense
                            suffix="Menit"
                            :allow-negative="false"
      
                            :color="set_color"
                            placeholder="Contoh. 5"
      
                            
      
                            v-model="form.duration"
                            :error-messages="errors"
                            required
                            style="border-radius: 10px;"
                            class="mb-0">
                          </v-currency-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
  
                    <ValidationProvider 
                      name="Sekolah"
                      rules="required"  
                      v-slot="{ errors }">
                      <div class="fs-13 mb-1">
                        
                        Sekolah
                        <span class="red--text">*</span>
                      </div>
  
                      <v-autocomplete
                        v-on:keyup.enter="save()"
  
                        solo
                        rounded
                        dense
  
                        :color="set_color"
                        placeholder="Contoh. SMP"
                        v-on:change="fetchTahun()"
  
                        :readonly="user.school_id !== undefined && user.school_id !== null"
  
                        :items="school"
                        item-text="name"
                        item-value="id"
                        :item-color="set_color"
  
                        v-model="form.school_id"
                        class="mb-0"
                        :error-messages="errors"
                        required
                        style="border-radius: 10px;">
                      </v-autocomplete>
                    </ValidationProvider>
  
                    <ValidationProvider 
                      name="Tahun Ajaran"
                      rules="required"  
                      v-slot="{ errors }">
                      <div class="fs-13 mb-1">
                        
                        Tahun Ajaran
                        <span class="red--text">*</span>
                      </div>
  
                      <v-autocomplete
                        v-on:keyup.enter="save()"
  
                        solo
                        rounded
                        dense
  
                        :color="set_color"
                        placeholder="Contoh. 2025"
  
                        
  
                        :items="tahun_ajaran"
                        item-text="value"
                        item-value="id"
                        :item-color="set_color"
  
                        v-model="form.tahun_ajaran_id"
                        class="mb-0"
                        :error-messages="errors"
                        required
                        style="border-radius: 10px;">
                      </v-autocomplete> 
                    </ValidationProvider>
                  </v-form>
                </ValidationObserver>
  
              </v-card-text>
              
              <v-divider 
                class="mt-2"
                style="border-top: 1px solid #e0e0e0;"/>
              
              <v-card-actions
                class="pa-4">
                <div v-if="message.error.length > 0"
                  class="text-left mt-0">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
                <v-spacer/>
  
                <v-btn
                  @click="save()"
                  :loading="process.form"
                  :disabled="process.form"
                  width="85"
                  elevation="0"
                  :color="set_color"
                  style="border-radius: 6px;"
                  class="fs-13 font-weight-bold text-capitalize white--text">
                  Simpan
                </v-btn>
  
                <v-btn
                  @click="dialog.form = false; reset();"
                  :disabled="process.form"
                  width="85"
                  outlined
                  elevation="0"
                  color="red"
                  style="border-radius: 6px;"
                  class="fs-13 font-weight-bold text-capitalize white--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog.delete"
            @keydown.esc="dialog.delete = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                Hapus Data
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second mt-4">
                Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
              </v-card-text>
  
              <div v-if="message.error.length > 0"
                class="text-center mx-6 my-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
  
              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-actions
                class="pa-4">
                <v-spacer/>
  
                <v-btn
                  rounded
                  width="120"
                  @click="deletes()"
                  :loading="process.delete"
                  :disabled="process.delete"
                  color="green"
                  elevation="0"
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Ya, Hapus
                </v-btn>
  
                <v-btn
                  rounded
                  width="120"
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  :disabled="process.delete"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          
          <section>
            <v-row
              class="pa-4 pb-0 pt-0">
              <v-col
                cols="12" class="pb-1 pt-1">
                <v-card
                  flat
                  color="#ffffff">
                  <v-card-text>
                    <div
                      class="d-flex align-center">
                      <div
                        class="d-flex align-center">
                        <v-icon
                          size="24"
                          :color="set_color">
                          mdi-menu
                        </v-icon>
    
                        <div
                          class="fs-16 black--text ml-3"
                          style="font-weight: 600; padding-top: 1px;">
                          {{ $route.meta.title }}
                        </div>
                      </div>
    
                      <v-spacer />
    
                      <div class="d-flex align-center">
                        <v-text-field
                          @click:clear="search = ''; fetch();"
                          v-on:keyup.enter="fetch()"
              
                          solo
                          rounded
                          dense
                          single-line
                          disabled
              
                          hide-details
                          :color="set_color"
                          placeholder="Cari data . . ."
                          prepend-inner-icon="mdi-magnify"
                          clearable
              
                          v-model="search"
                          class="fs-12 little-placeholder"
                          style="border-radius: 6px; background: #fff !important; max-width: 320px">
                        </v-text-field>
  
                        <v-autocomplete
                          v-on:change="fetch()"
              
                          solo
                          rounded
                          dense
                          single-line
              
                          hide-details
                          disabled
                          :color="set_color"
                          placeholder="Pilih Sekolah"
                          prepend-inner-icon="mdi-magnify"
                          :items="school"
                          item-text="name"
                          item-value="id"
                          v-if="(user.school_id === undefined || user.school_id === null) &&($store.state.school === null || $store.state.school === undefined || undefined === '')"
              
                          v-model="filter.school_id"
                          class="fs-12 little-placeholder ml-3"
                          style="border-radius: 6px; background: #fff !important; max-width: 400px">
                        </v-autocomplete>
  
                        <v-btn
                          @click="dialog.form = true; reset();"
                          :color="set_color"
                          elevation="0"
                          small
                          disabled
                          min-height="36"
                          class="fs-12 white--text text-capitalize d-flex align-center ml-3"
                          style="border-radius: 6px; font-weight: 600;">
                          <span
                            class="ml-0">
                            Tambah
                          </span>
                        </v-btn>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
  
            <v-row
              class="pa-4">
              <v-col 
                cols="12"
                class="py-0">
                <v-card 
                  flat
                  style="border-radius: 6px;">
                  <v-card-text>
                    <div
                      class="d-flex align-center justify-center" style="height: calc(100vh - 250px);">
                      <div>
                        <v-img 
                          class="mx-auto"
                          contain
                          alt="vuetify"
                          :width="300"
                          :height="300"
                          :src="require('@/assets/icon/coming-soon.png')">
                          <template v-slot:placeholder>
                            <v-row
                              class=" "
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
    
                        <!-- <div 
                          class="font-weight-light text-second my-6">
                          Pilih <b>Sekolah</b> terlebih dahulu!!!
                        </div> -->
                      </div>
                    </div>
  
                  </v-card-text>
                  <v-card-text v-if="filter.school_id === '' || filter.school_id === null">
                    <v-data-table
                      v-model="selected.row"
                      ref="table-grid"
                      class="table-grid"
                      :height="`calc(100vh - ${pagination.total_data > 0 ? '315px' : '248px'})`"
                      :show-select="checkbox"
                      :single-select="true"
                      :loading="process.load"
                      loading-text="Sedang memuat data . . ."
                      loader-height="5"
                      no-results-text="Belum ada data"
                      :options.sync="options"
                      :headers="configHeaders"
                      :items="list"
                      :items-per-page="100"
                      item-key="id"
                      @click:row="rowClick"
                      @toggle-select-all="handleToggleAll($event)"
                      @dblclick:row="doubleClick"
                      hide-default-footer
                      hide-default-header>
                      <template v-slot:header="{ props: { headers } }">
                        <thead>
                          <tr>
                            <th v-for="h in headers" :key="h" :style="`min-width: ${h.width === '' ? '' : h.width }; width: ${h.width === '' ? '' : h.width };background-color: #f3f4f6 !important; color: #000 !important;`" :class="`text-${h.align}`">
                              <span>{{h.text}}</span>
                            </th>
                          </tr>
                        </thead>
                      </template>
                      <template
                        v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                        v-slot:[`item.${header.value}`]="{ value, index, item }">
                        <div
                          v-bind:key="header.value">
                          <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'">
                            {{ rowFormat(header.format, value) }} 
                          </div>
    
                          <div v-if="header.format === 'link'"
                            class="cursor-pointer">
                            {{ item.duration | number }} Menit
                          </div>
            
                          <div v-if="header.format === 'regex'">
                            <span
                              class="two-line">
                              {{ rowFormat(header.format, value) }}
                            </span>
                          </div>
            
                          <div v-if="header.format === 'image'"
                            class="ma-4">
                            <v-avatar
                              size="60"
                              tile
                              style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                              <v-img 
                                contain
                                width="100%"
                                height="100%"
                                alt="POS Amanata" 
                                :src="value !== '' ? value : require('@/assets/image/member_default.png')"
                                class="ma-auto">
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height"
                                    align="center"
                                    justify="center">
                                    <v-progress-circular 
                                      size="20"
                                      indeterminate 
                                      :color="set_color">
                                    </v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-avatar>
                          </div>
    
                          <div v-if="header.format === 'image_potrait'"
                            class="ma-4">
                            <v-img 
                              contain
                              width="100"
                              height="125"
                              alt="POS Amanata" 
                              :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                              class="ma-auto"
                              style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    size="20"
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>
    
                          <div v-if="header.format === 'image_landscape'"
                            class="ma-4">
                            <v-img 
                              contain
                              width="200"
                              height="125"
                              alt="POS Amanata" 
                              :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                              class="ma-auto"
                              style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    size="20"
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>
    
                          <div v-if="header.format === 'action'">
                            <v-tooltip 
                              top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  @click="reset(index); dialog.form = true;"
                                  
                                  v-bind="attrs"
                                  v-on="on"
    
                                  min-width="25"
                                  height="25"
                                  x-small
                                  rounded
                                  color="#3b3f5c"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 8px;">
                                  <v-icon size="13">mdi-pencil-outline</v-icon>
                                </v-btn>
                              </template>
    
                              <span>Ubah</span>
                            </v-tooltip>
    
                            <v-tooltip 
                              top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  @click="toDelete(item.id)"
    
                                  v-bind="attrs"
                                  v-on="on"
    
                                  min-width="25"
                                  height="25"
                                  x-small
                                  rounded
                                  color="#e7515a"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 8px;">
                                  <v-icon size="13">mdi-trash-can-outline</v-icon>
                                </v-btn>
                              </template>
                              
                              <span>Hapus</span>
                            </v-tooltip>
                          </div>
    
                          <div v-if="header.format === 'bool'"
                            class="d-flex align-center justify-center">
                            <!-- <v-switch
                              @change="toStatus(value, index)"
                              v-model="value"
                              color="success"
                              class="ma-auto"
                              hide-details>
                            </v-switch> -->
                          </div>
    
                          <div v-if="header.format === 'status'"
                            class="d-flex justify-center">
                            
                          </div>
                        </div>
                      </template>
    
                      <template v-slot:[`item.index`]="{ index }">
                        {{ lastIndex + index }}
                      </template>
    
                      <v-progress-linear 
                        v-show="process.load" 
                        slot="progress" 
                        color="white" 
                        indeterminate>
                      </v-progress-linear>
                    </v-data-table>
                    <pagination v-if="pagination.total_data > 0"
                      @changePage="fetch($event)" 
                      @reloadPage="fetch($event)" 
                      :model="pagination" :display="paginationList"/>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { TokenService } from "@/service/Storage.Service";
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import axios from "axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          checkbox: false,
  
          dialog: {
            fullscreen: false,
            snackbar: false,
            freeze: false,
            hide: false,
  
            delete: false,
            reset: false,
            role: false,
  
            filter: false,
            form: false
          },
          
          search: '',
  
          filter: {
            school_id: '',
          },
  
          center: {
            lat: -7.703889, 
            lng: 110.60166
          },
          
          upload: {
            image: ''
          },
          selected: {
            row: [],
            freeze: [],
            delete: [],
            reset: [],
            role: []
          },
  
          paginationList: {
            row: 20,
            page: 1
          },
  
          role: [],
          sortBy: 'id',
          sortDesc: '-',
  
          options: {},
          headers: [],
          list: [],
          pagination: {},
  
          lastIndex: 0,
          limit: 20,
  
          form: {
            id: '',
            school_id: '',
            tahun_ajaran_id: '',
            code: '',
            name: '',
            singkatan: '',
            duration: '',
          },
  
          school: [],
          pegawai: [],
          kelas: [],
          tahun_ajaran: [],
  
          process: {
            load: false,
  
            delete: false,
            reset: false,
            role: false,
            export: false,
            image: false,
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue'),
        uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
      },
      watch: {
        'upload.image': {
          handler: function () {
            if (this.upload.image) {
              this.process.image = this.upload.image.process
  
              if (!this.process.image) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.logo_url = this.upload.image.fileuri
  
                // this.save_image()
              }
            }
          },
          deep: true
        }
        // 'options': {
        //   handler () {
        //     let pagination = { row: this.limit, page: 1 }
            
        //     this.fetch(pagination)
        //   },
        //   deep: true
        // }
      },
      computed: {
        rps () {
          return this.$vuetify.breakpoint.name
        },
        user () {
          this.filter.school_id = this.$store.state.user.school_id === undefined || this.$store.state.user.school_id === null ? this.$store.state.school !== undefined && this.$store.state.school !== null && this.$store.state.school !== '' ? this.$store.state.school : '' : this.$store.state.user.school_id
          return this.$store.state.user
        },
        fcm () {
          return this.$store.state.fcm
        },
        data_menu () {
          let menu = {}
          this.$store.state.menu.map((item, index) => {
            if (item.link.split('/')[1] === this.$route.path.split('/')[1]) {
              item.sub_menu.map((sub, index) => {
                if (sub.link === this.$route.path) {
                  menu = sub
                }
              })
            }
          })
  
          return menu
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        },
  
        configHeaders () {
          return this.headers.filter(header => !header.hide)  
        },
        years () {
          let max = new Date('10-01-2023').getFullYear()+10, min = max - 10, years = []
          // console.log(new Date('10-01-2024').getFullYear())
  
          this.filter.year = this.$store.state.year
  
          for (let i = max; i >= min; i--) {
            years.push({
              text: i,
              value: i
            })
          }
  
          return years
        }
      },
      mounted () {
        this.fetch()
        this.fetchSchool()
        this.fetchTahun()
      },
      methods: {
        async fetchSchool() {
  
            let params = {
            limit: 10000000000000
          }
  
            let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/school/data' : 'school/data'
            await get(`${url}`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.school = res.results.data
            }
          })
        },
        async fetchTahun() {
  
            let params = {
            limit: 10000000000000,
            school_id: this.form.school_id
          }
  
          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/tahun_ajaran/data' : 'tahun_ajaran/data'
          await get(`${url}`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.tahun_ajaran = res.results.data
            }
          })
        },
        toSort(name) {
          this.sortBy = name
          this.sortDesc = ''
          this.fetch()
        },
        toDesc() {
          this.sortDesc === '-' ? this.sortDesc = '' : this.sortDesc = '-'
          this.fetch()
        },
        rowFormat (format, value) {
          let data = value
  
          if (format === 'number') {
            if (isNaN(value)) return 'Not a Number'
            let price = ''
  
            const reverseNumber = value
              .toString()
              .split('')
              .reverse()
              .join('')
            const arrReverseNumber = [...Array(reverseNumber.length).keys()]
  
            arrReverseNumber.map(index => {
              if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
            })
  
            return `Rp ${
              price.split('', price.length - 1)
              .reverse()
              .join('')
            }`
          } else if (format === 'array') {
            let arr = []
  
            for (let i = 0; i < value.length; i++) {
              arr.push(value[i].label)
            }
  
            data = arr.join(', ')
          } else if (format === 'date') {
            data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
          } else if (format === 'time') {
            data = value.length > 0 ? moment(value).format('HH:mm') : '-'
          } else if (format === 'datetime') {
            data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
          } else if (format === 'object') {
            data = value.createdby.name
          } else if (format === 'regex') {
            let regex = /(<([^>]+)>)/ig
  
            data = value.replace(regex, '')
          } else if (format === 'underscore') {
            let regex = /_/g
  
            data = value.replace(regex, ' ')
          } else if (format === 'on_off') {
            data = value ? 'Online' : 'Offline'
          } else if (format === 'g_m') {
            data = value ? 'Mandiri' : 'Group'
          } else if (format === 'v_a') {
            data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
          } else if (format === 'y_n') {
            data = parseInt(value) ? 'Ya' : 'Tidak'
          } else if (format === 'percent') {
            data = Number(value) + ' %'
          } else if (format === 'action') {
            data = value
          } else if (format === 'bool') {
            data = value
          } else if (format === 'status') {
            data = value
          } else if (format === 'link') {
            data = value
          }  else {
            data = value ? 'Aktif' : 'Tidak Aktif'
          }
  
          return data
        },
        rowClick (item, row) {
          row.select(!row.isSelected ? true : false)
        },
        doubleClick (event, {item}) {
          // NO ACTION
        },
        handleToggleAll (event) {
          if (!event.value) this.selected.row = []
        },
  
        async fetch (pagination = { row: 20, page: 1 }) {
          this.process.load = true
  
          this.limit = pagination.row
          this.paginationList = pagination
  
          let params = {
            limit: pagination.row,
            page: pagination.page,
            sort: `${this.sortDesc}${this.sortBy}`,
            school_id: this.filter.school_id,
            // sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
            // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
            search: this.search
          }
  
          this.selected.row = []
  
            let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/mapel/data' : 'bidang_studi/data'
  
          await get(`${url}`, { params })
          .then(response => {
            let res = response.data
  
            // this.process.load = false
  
            this.list = []
            this.pagination = {}
              
            if (res.status === 200) {
              this.headers = [
                {
                  text: 'Aksi',
                  width: '80px',
                  value: 'id',
                  freeze: true,
                  hide: false,
                  align: 'center',
                  format: 'action'
                },
                {
                  text: 'Nama Mata Pelajaran',
                  value: 'name',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'Kode',
                  width: '100px',
                  value: 'code',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'Singkatan',
                  width: '100px',
                  value: 'singkatan',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'Durasi',
                  width: '100px',
                  value: 'duration',
                  freeze: false,
                  hide: false,
                  format: 'link'
                },
                {
                  text: 'Tahun Ajaran',
                  width: '500px',
                  value: 'tahun_ajaran',
                  freeze: false,
                  hide: false
                }
              ]
  
              this.list = res.results.data
              this.pagination = res.results.pagination
  
              this.list.map(obj => {
                obj.is_active = obj.is_active === '1' ? true : false
              })
  
              this.lastIndex = (pagination.page - 1) * pagination.row 
              this.lastIndex += 1
  
              this.addFreezes()
  
              this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })
  
              if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
            }
          })
        },
  
        addFreezes () {
          this.removeFreezes()
  
          this.selected.freeze = []
  
          for (let i = 0; i < this.configHeaders.length; i++) {
            if (this.configHeaders[i].freeze) {
              // ADD TO SELECTOR
              this.selected.freeze.push({
                child: i + (this.checkbox ? 2 : 1),
                width: this.configHeaders[i].width.split('px')[0]
              })
  
              // LOOP STYLESHEET
              for (let f = 0; f < this.selected.freeze.length; f++) {
                let style = document.createElement('style'),
                    width = 0
  
                if (this.checkbox) {
                  width = f < 1 ? '65' : 
                        f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                        parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
                } else {
                  width = f < 1 ? '0' : 
                        f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                        parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
                }
  
                // ADD STYLESHET TO FREEZE
                style.innerHTML = `
                  .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                    left: ${width}px;
                    z-index: 5;
                    background: #FFFFFF;
                  }
  
                  .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                    left: ${width}px;
                    z-index: 1;
                  }
                `
  
                // ADD TO APPENDCHILD
                document.head.appendChild(style)
              }
            }
          }
        },
        removeFreezes () {
          // LOOP STYLESHEET
          for (let f = 0; f < this.selected.freeze.length; f++) {
            let style = document.createElement('style')
            
            // RESET STYLESHEET TO AUTO
            style.innerHTML = `
              .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                left: auto;
                z-index: auto;
                background: #FFFFFF;
              }
  
              .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                left: auto;
                z-index: auto;
              }
            `
  
            // ADD TO APPENDCHILD
            document.head.appendChild(style)
          }
        },
        addHides () {
          if (this.headers.length < 6) this.getTableToResize()
        },
        getTableToResize () {
          let tables = document.getElementsByTagName('table')
  
          for (let i = 0; i < tables.length; i++) {
            this.resizableGrid(tables[i])
          }
        },
        resizableGrid (table) {
          let row = table.getElementsByTagName('tr')[0],
              cols = row ? row.children : undefined
          
          if (!cols) return
          
          table.style.overflow = 'hidden'
          
          let tableHeight = table.offsetHeight
          
          for (let i = 0; i < cols.length; i++) {
            let div = createDiv(tableHeight)
            cols[i].appendChild(div)
            cols[i].style.position = 'relative'
  
            setListeners(div)
          }
  
          function setListeners (div) {
            let pageX, curCol, nxtCol, curColWidth, nxtColWidth
  
            div.addEventListener('mousedown', e => {
              curCol = e.target.parentElement
              nxtCol = curCol.nextElementSibling
              pageX = e.pageX
              
              let padding = paddingDiff(curCol)
              
              curColWidth = curCol.offsetWidth - padding
  
              if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
            })
  
            div.addEventListener ('mouseover', e => {
              e.target.style.borderRight = '2px solid #e0e0e0'
            })
  
            div.addEventListener ('mouseout', e => {
              e.target.style.borderRight = ''
            })
  
            document.addEventListener ('mousemove', e => {
              if (curCol) {
                let diffX = e.pageX - pageX
            
                if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'
  
                curCol.style.width = (curColWidth + diffX)+'px'
              }
            })
  
            document.addEventListener ('mouseup', () => { 
              curCol = undefined
              nxtCol = undefined
              pageX = undefined
              nxtColWidth = undefined
              curColWidth = undefined
            })
          }
  
          function createDiv (height) {
            let div = document.createElement('div')
  
            div.style.top = 0
            div.style.right = 0
            div.style.width = '1px'
            div.style.position = 'absolute'
            div.style.cursor = 'col-resize'
            div.style.userSelect = 'none'
            div.style.height = height + 'px'
            div.style.background = 'transparent'
  
            return div
          }
  
          function paddingDiff (col) {
            if (getStyleVal(col,'box-sizing') == 'border-box') {
              return 0
            }
            
            let padLeft = getStyleVal(col,'padding-left')
            let padRight = getStyleVal(col,'padding-right')
  
            return (parseInt(padLeft) + parseInt(padRight))
          }
  
          function getStyleVal (elm,css) {
            return (window.getComputedStyle(elm, null).getPropertyValue(css))
          }
        },
  
        reset (index) {
          if (this.$refs.form) this.$refs.form.reset()
          
          this.form = {
            id: index !== undefined ? this.list[index].id : '',
            school_id: index !== undefined ? this.list[index].school_id : this.filter.school_id,
            tahun_ajaran_id: index !== undefined ? this.list[index].tahun_ajaran_id : '',
            code: index !== undefined ? this.list[index].code : '',
            name: index !== undefined ? this.list[index].name : '',
            singkatan: index !== undefined ? this.list[index].singkatan : '',
            duration: index !== undefined ? this.list[index].duration : ''
          }

          this.fetchTahun()
  
          this.process.form = false
  
          this.message.error = ''
        },
  
        async save () {
          this.message.error = ''
  
          const isValid = await this.$refs.form.validate()
  
          if (isValid) {
            this.process.form = true
  
            let url = this.form.id === '' ? 'mapel/add' : 'mapel/update'
  
            // SAVE TO REST API
            await post(url, {
              data: this.form
            })
            .then(response => {
              let res = response.data
              
              this.process.form = false
  
              if (res.status === 200) {
                this.dialog.form = false
  
                this.dialog.snackbar = true
                this.message.success = res.message
  
                this.dialog.fullscreen = false
  
                if (this.form.id === '') {
                  this.fetch()
                } else {
                  this.fetch(this.paginationList)
                }
                this.reset()
  
              } else {
                this.message.error = res.message
              }
            })
  
          } else {
            // AUTO FOCUS ON TEXT-FIELD
            setTimeout(() => {
              const errors = Object.entries(this.$refs.form.errors)
                .map(([key, value]) => ({ key, value }))
                .filter(error => error['value'].length)
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }, 10)
          }
        },
  
        toDelete (id) {
          this.selected.delete = [id]
  
          this.dialog.delete = true
        },
        async deletes () {
          this.message.error = ''
  
          this.process.delete = true
  
          await post(`mapel/delete`, {
            data: {
              id: this.selected.delete[0],
              school_id: this.filter.school_id
            }
          }).then(response => {
            let res = response.data
  
            this.process.delete = false
  
            if (res.status === 200) {
  
              this.dialog.delete = false
  
              this.selected.row = []
              this.selected.delete = []
              
              this.dialog.snackbar = true
              this.message.success = res.message
  
              this.dialog.fullscreen = false
  
              this.fetch()
            } else {
              this.message.error = res.message
            }
          })
        },
      }
    }
  </script>
  
  <style>
    /* ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
      background-color: #F5F5F5;
    }
    ::-webkit-scrollbar-track{
      background-color: #F5F5F5;
      border-radius: 10px;
    } */
    ::-webkit-scrollbar-thumb{
      border-radius: 5px;
    }
  </style>